import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  BalanceSheet = 'BalanceSheet',
}

export const queryKeys = {
  balanceSheet: (clientId: number, owners: string[] | null) => {
    const base = [QueryFeature.NetWorth, QueryKey.BalanceSheet, clientId];

    if (owners) {
      return [...base, owners.join(',')];
    }

    return base;
  },
};
